import AutomationError from './AutomationError';
class InvestorsFiscalRegimeNotAllowed extends AutomationError {
    constructor(options) {
        super('The investor’s fiscal regime is not supported for automatic invoicing.', options);
    }
}
export default InvestorsFiscalRegimeNotAllowed;
